export const commandBarEvent = {
  open: 'opened',
  close: 'closed',
  commandExecution: 'command_execution',
  profileCompletionSubmitted: 'profile_completion_submitted',
}

export const commandBarCallback = {
  showCompleteYourProfileModal: 'show_complete_your_profile_modal',
}

export const commandBarChecklist = {
  getStartedDeveloper: 1843,
  getStartedContentEditor: 1919,
}
